import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './client';

/** Errors that will not change on retry. */
const NO_RETRY = new Set(['UNAUTHENTICATED', 'FORBIDDEN', 'NOT_FOUND', 'VALIDATION_FAILED', 'TENANT_SUSPENDED', 'VERSION_CONFLICT', 'CONFLICT', 'INVALID_STATE', 'QUOTA_EXCEEDED']);

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, err) => !(isApiError(err) && NO_RETRY.has(err.code)) && count < 2,
      },
      mutations: { retry: false },
    },
  });
}
